import * as a from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/HandsClapping.es.js";
const o = a.forwardRef((n, p) => /* @__PURE__ */ a.createElement(e, { ref: p, ...n, weights: r }));
o.displayName = "HandsClappingIcon";
const i = o;
export {
  i as HandsClapping,
  o as HandsClappingIcon
};
